// extracted by mini-css-extract-plugin
export default {"root":"MFA_root__rLlaT","title":"MFA_title__GS055","subTitle":"MFA_subTitle__RLJ3r","delete":"MFA_delete__6IDMK","badge":"MFA_badge__ks1MY"};